import axios from 'axios'

//https://seosuite.it
//http://localhost:3005

export default axios.create({
    baseURL: process.env.REACT_APP_API_URL
})